import { render } from "./AccessoriesRating.vue?vue&type=template&id=6cba2994"
import script from "./AccessoriesRating.vue?vue&type=script&lang=js"
export * from "./AccessoriesRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__